import { getCurrentScreen, track } from '@/shared/analytics';

/** Установка PWA на устройство (Chromium; Safari такого события не даёт) */
export function watchAppInstalled(): void {
  window.addEventListener('appinstalled', () => track('app_installed'));
}

/**
 * Ответ на системный запрос геолокации. Запрос делают несколько экранов,
 * поэтому слушаем само разрешение: prompt → granted / denied. Где Permissions
 * API не знает geolocation (старый Safari, часть WebView), событий не будет
 */
export async function watchLocationPermission(): Promise<void> {
  if (!navigator.permissions?.query) return;

  try {
    const status = await navigator.permissions.query({ name: 'geolocation' });
    let previous = status.state;

    status.addEventListener('change', () => {
      const next = status.state;
      if (previous === 'prompt' && next !== 'prompt') {
        track(
          next === 'granted'
            ? 'location_permission_granted'
            : 'location_permission_denied',
          { source: getCurrentScreen() }
        );
      }
      previous = next;
    });
  } catch {
    // Разрешение не узнать — событий нет, приложение работает как обычно
  }
}
